import 'lazysizes';
import objectFitImages from 'object-fit-images';
import animate from 'animate-vanilla-js';
import Marquee from 'vanilla-marquee';

import './menu';
import './slideshow';
import './video';
import './slider';
import './a11y-video';
import './resources';
import './filter';

objectFitImages();

document.addEventListener('DOMContentLoaded', () => {
  /**
   * Initialize aria visibility toggles.
   *
   * Usage:
   *    <button aria-expanded="false" aria-controls="myDropdown">Toggle</button>
   *    <div id="myDropdown" aria-hidden="true">Dropdown</div>
   */
  document.querySelectorAll('[aria-controls]').forEach((el) => {
    el.addEventListener('click', (e) => {
      const id = el.getAttribute('aria-controls');
      const controlled = document.getElementById(id);
      const open = controlled.getAttribute('aria-hidden') !== 'false';

      controlled.setAttribute('aria-hidden', open ? 'false' : 'true');

      document.querySelectorAll(`[aria-controls="${id}"]`).forEach((el) => {
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      e.preventDefault();
    });
  });

  // Expand & contract details & summary items
  const expanderItems = document.querySelectorAll('.js-expander-item');

  if (expanderItems) {
    expanderItems.forEach((item) => {
      const toggle = item.querySelector('.js-expander-item-toggle');
      const dropdownWrapper = item.querySelector('.dropdown-wrapper');
      const durationVar = getComputedStyle(item, null).getPropertyValue(
        '--expander-duration'
      );
      const duration = durationVar ? durationVar.slice(0, -2) : 150;

      toggle.addEventListener('click', function (event) {
        // first a guard clause: don't do anything
        // if we're already in the middle of closing the menu.
        if (item.classList.contains('item-closing')) {
          return;
        }
        // but, if the menu is open ...
        if (item.open) {
          // prevent default to avoid immediate removal of "open" attribute
          event.preventDefault();
          // add a CSS class that contains the animating-out code
          item.classList.add('item-closing');

          animate(
            dropdownWrapper.clientHeight,
            0,
            duration,
            'easeInOutQuad',
            (value) => {
              dropdownWrapper.style.height = `${value}px`;
            }
          ).then(() => {
            dropdownWrapper.style.cssText = '';
            item.removeAttribute('open');
            item.classList.remove('item-closing');
          });
        } else {
          event.preventDefault();
          item.setAttribute('open', '');

          // Get the height before it's visible
          dropdownWrapper.style.opacity = '0';
          dropdownWrapper.style.position = 'absolute';
          const wrapperHeight = dropdownWrapper.clientHeight;
          dropdownWrapper.style.opacity = '';
          dropdownWrapper.style.position = '';
          animate(0, wrapperHeight, duration, 'easeInOutQuad', (value) => {
            dropdownWrapper.style.height = `${value}px`;
          }).then(() => {
            dropdownWrapper.style.cssText = '';
          });
        }
      });
    });
  }

  // init marquees
  setTimeout(function () {
    document.querySelectorAll('[data-marquee]').forEach((el) => {
      /* eslint-disable no-new */
      const marquee = new Marquee(el, {
        duplicated: true,
        gap: 0,
        speed: 50,
        startVisible: true,
        recalcResize: true,
        delayBeforeStart: 0,
      });

      // Refresh soon after init to fix speed
      setTimeout(function () {
        marquee.refresh();
      }, 250);
    });
  }, 0);
});
